import styled from '@emotion/styled';

import { GridTheme } from './types';

export const GridElement = styled.div<{ theme: GridTheme }>`
  scrollbar-color: ${(props) =>
    `${props.theme.scrollbar.color} ${props.theme.scrollbar.background}`} !important;

  &::-webkit-scrollbar {
    background: ${(props) => props.theme.scrollbar.background} !important;
  }

  &::-webkit-scrollbar-track {
    background: ${(props) => props.theme.scrollbar.background} !important;
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${(props) => props.theme.scrollbar.color} !important;

    &:hover {
      background-color: ${(props) => props.theme.scrollbar.color} !important;
    }

    &:active {
      background-color: ${(props) => props.theme.scrollbar.color} !important;
    }
  }
`;
